import React from 'react'
import Filters, { FilterGroup } from '../organisms/Filters'
import type { OrderType, DealType, SortBy, SortDirection } from '@/types/otc'

export interface OTCFiltersProps {
  search: string
  onSearchChange: (value: string) => void
  type: OrderType | ''
  onTypeChange: (value: OrderType | '') => void
  assetType: DealType | ''
  onAssetTypeChange: (value: DealType | '') => void
  trancheSize: string
  onTrancheSizeChange: (value: string) => void
  sortBy: SortBy | ''
  onSortByChange: (value: SortBy | '') => void
  sortDirection: SortDirection | ''
  onSortDirectionChange: (value: SortDirection | '') => void
  className?: string
  layout?: 'horizontal' | 'grid'
}

const OTCFilters: React.FC<OTCFiltersProps> = ({
  search,
  onSearchChange,
  type,
  onTypeChange,
  assetType,
  onAssetTypeChange,
  trancheSize,
  onTrancheSizeChange,
  sortBy,
  onSortByChange,
  sortDirection,
  onSortDirectionChange,
  className,
  layout = 'horizontal'
}) => {
  const filterGroups: FilterGroup[] = [
    {
      id: 'type',
      label: 'Type',
      value: type,
      onChange: onTypeChange as (value: string) => void,
      options: [
        { value: '', label: 'All Types' },
        { value: 'BUY', label: 'Buy' },
        { value: 'SELL', label: 'Sell' }
      ]
    },
    {
      id: 'assetType',
      label: 'Asset Type',
      value: assetType,
      onChange: onAssetTypeChange as (value: string) => void,
      options: [
        { value: '', label: 'All Assets' },
        { value: 'LIQUID_TOKEN', label: 'Liquid Token' },
        { value: 'SAFT', label: 'SAFT' },
        { value: 'EQUITY', label: 'Equity' },
        { value: 'EQUITY_WARRANT', label: 'Equity Warrant' },
        { value: 'NFT', label: 'NFT' }
      ]
    },
    {
      id: 'trancheSize',
      label: 'Order Size',
      value: trancheSize,
      onChange: onTrancheSizeChange,
      options: [
        { value: '', label: 'All Sizes' },
        { value: '10k-100k', label: '10k - 100k' },
        { value: '100k-250k', label: '100k - 250k' },
        { value: '250k-500k', label: '250k - 500k' },
        { value: '1m+', label: '1m+' }
      ]
    },
    {
      id: 'sortBy',
      label: 'Sort By',
      value: sortBy,
      onChange: onSortByChange as (value: string) => void,
      options: [
        { value: '', label: 'Sort By' },
        { value: 'DATE', label: 'Date' },
        { value: 'PROJECT_NAME', label: 'Project Name' },
        { value: 'OFFERED_AMOUNT', label: 'Offered Amount' }
      ]
    },
    {
      id: 'sortDirection',
      label: 'Sort Order',
      value: sortDirection,
      onChange: onSortDirectionChange as (value: string) => void,
      options: [
        { value: '', label: 'Sort Order' },
        { value: 'ASC', label: 'Ascending' },
        { value: 'DESC', label: 'Descending' }
      ]
    }
  ]

  return (
    <Filters
      searchPlaceholder="Search by project name..."
      searchValue={search}
      onSearchChange={onSearchChange}
      filterGroups={filterGroups}
      className={className}
      layout={layout}
    />
  )
}

export default OTCFilters

